
import moment from 'moment';
import login from '../../modules/auth/application/login';
import OrderNotFoundError from '../../modules/auth/domain/OrderNotFoundError';
import createAuthApiRepository from '../../modules/auth/infrastructure/AuthApiRepository';
import orderDetail from '../../libs/mixins/orderDetail';
import saveLoginData from '../../libs/utils/authUtils';

export default {
  mixins: [orderDetail],

  data() {
    return {
      email: '',
      error: null,
      isLoading: false,
      showTutorial: 0,
      showNoticePrivacy: false,
    };
  },

  computed: {
    bannerColor() {
      if (this.error instanceof OrderNotFoundError) {
        return 'purple-custom';
      }

      return 'negative';
    },
  },

  methods: {
    async login() {
      this.isLoading = true;

      try {
        const repository = createAuthApiRepository();

        const data = await login(repository, {
          email: this.email,
          orderHigherIdExt: this.$session.get('superOrderId'),
        });

        this.saveTokenInSession(data.token, data.expires_in);

        const { showTutorial, showNoticePrivacy } = saveLoginData(this.$session, data, this.email);

        this.showTutorial = showTutorial;
        this.showNoticePrivacy = showNoticePrivacy;

        await this.getOrderDetail();
      } catch (error) {
        this.error = error;
      } finally {
        localStorage.setItem('isInternal', '0');
        this.isLoading = false;
      }
    },

    saveTokenInSession(token, expiresIn) {
      localStorage.setItem('token', token);
      this.$session.set('token', token);
      this.$session.set('expire_date', moment().add(expiresIn, 'seconds').format('YYYY-MM-DD HH:mm'));
    },
  },
};
